import Vue from 'vue'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'croppie/croppie.css'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@/styles/index.scss'
import SvgFiller from 'vue-svg-filler'
import firebase from 'firebase/app'
import 'firebase/auth'
import VueCurrencyFilter from 'vue-currency-filter'
import settings from '@/settings'
import moment from 'moment'
import VueCroppie from 'vue-croppie'

moment.locale('pt-br')
Vue.config.productionTip = false

Vue.component('svg-filler', SvgFiller)
Vue.use(VueCroppie)
Vue.use(VueCurrencyFilter,
  {
    symbol: 'R$',
    thousandsSeparator: '.',
    fractionCount: 2,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: true
  })
Vue.filter('formatDate', (value, format) => {
  if (value) {
    return moment(String(value)).format(format)
  }
})
Vue.filter('formataTelefone', (value) => {
  if (!value) return value
  const numeros = value.toString().replace(/\D/g, '')
  const tamanho = numeros.length

  if (tamanho === 10) {
    return numeros.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3')
  } else if (tamanho === 11) {
    return numeros.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
  }

  return value
})
new Vue({
  router,
  store,
  render: h => h(App),
  created () {
    firebase.initializeApp(settings.firebaseConfig)
  },
  mounted () {
    firebase.auth().onAuthStateChanged((user) => {
      this.$store.dispatch('userChanged', user)
    })
  }
}).$mount('#app')
